var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-message"},[_c('SpinnerOne',{staticClass:"spinner"}),_c('h1',{staticClass:"load-header"},[_vm._v(_vm._s(_vm.header))]),_c('div',{staticClass:"load-message"},[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }